import React, { useState } from 'react'
import { Form, Input, Button, Card } from 'antd'
import { MailOutlined, SendOutlined, CheckCircleFilled } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import logo from '@/assests/Shakthi Power outline logo.png'
import { api, ApiError } from '@/services/api'
import './LoginPage.css'

const ForgotPasswordPage: React.FC = () => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const onFinish = async (values: { email: string }) => {
    setError('')
    setLoading(true)
    try {
      await api.forgotPassword(values.email)
      setSent(true)
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Cannot reach the server. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="lp-root-centered">
      <div className="lp-bg-glow glow-1" />
      <div className="lp-bg-glow glow-2" />
      <div className="lp-bg-glow glow-3" />

      <div className="lp-card-container">
        <div className="lp-logo-header">
          <img src={logo} alt="Shakthi Power Logo" className="lp-logo-main" />
        </div>

        <Card className="lp-glass-card">
          <div className="lp-card-header">
            <h2>Forgot Password</h2>
            <p>We'll email you a link to reset it</p>
          </div>

          {error && (
            <div className="lp-error-alert">
              <span>{error}</span>
            </div>
          )}

          {sent ? (
            <div style={{ textAlign: 'center', color: 'rgba(255,255,255,0.75)', padding: '12px 0' }}>
              <CheckCircleFilled style={{ fontSize: 32, color: '#059669', marginBottom: 12 }} />
              <p>If that email is registered, a reset link has been sent. Check your inbox.</p>
              <Link to="/login" className="lp-forgot-link">Back to login</Link>
            </div>
          ) : (
            <Form form={form} layout="vertical" onFinish={onFinish} autoComplete="off" requiredMark={false} className="lp-form-dark">
              <Form.Item
                name="email"
                label="Email Address"
                rules={[
                  { required: true, message: 'Please enter your email' },
                  { type: 'email', message: 'Enter a valid email address' },
                ]}
              >
                <Input prefix={<MailOutlined className="input-icon" />} placeholder="your@email.com" size="large" />
              </Form.Item>

              <Form.Item style={{ marginBottom: 16 }}>
                <Button type="primary" htmlType="submit" size="large" block loading={loading} icon={<SendOutlined />} className="lp-btn-submit">
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </Button>
              </Form.Item>

              <div style={{ textAlign: 'center' }}>
                <Link to="/login" className="lp-forgot-link">Back to login</Link>
              </div>
            </Form>
          )}
        </Card>

        <div className="lp-footer-text">
          © {new Date().getFullYear()} Shakthi Power ERP. All rights reserved.
        </div>
      </div>
    </div>
  )
}

export default ForgotPasswordPage
